/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import Utils from '../../../../lib/utils';
import PhoneInput from '../../../FormComponents/PhoneInput';
import classnames from 'classnames';
import './index.scss';

Modal.setAppElement('#root');

const errorMessage = {
                      firstname:'Please enter first name',
                      lastname:'Please enter last name',
                      email:'Please enter a valid email',
                      phone:'Please enter a valid phone number',
                      role: 'Please select a role',
                      login_type:'Please select Login type'
                    };
const titles = {
  STAFF:'Add Business Staff Member',
  MARKETING:'Add Marketing Staff Member'
}

const customStyles = {
  control: () => ({
    padding:'5px'
  }),
}
class CreateLayover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.startRef = React.createRef();
    this.endRef = React.createRef();
    this.state={
      firstname:'',
      lastname:'',
      email:'',
      phone:'',
      role:'STAFF',
      errors:[],
      roles:[],
      agency:''
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.staff.adding===true && nextProps.staff.adding===false){
      this.props.closeCampaignModel();
    }
    
  }

  componentDidMount(){
    console.log('roles',this.props);
    if(this.props.business && this.props.business.clientUser.domain && this.props.business.clientUser.domain.client_roles){
      let roles = this.props.business.clientUser.domain.client_roles.map(role=>{
        return {value:role, label:role}
      });
      this.setState({
        roles
      })
    }
  }

  closeModal() {
    this.props.closeCampaignModel();
  }

  addCampaign = () =>{
    const { firstname,lastname, email, phone, role , agency} = this.state;
    const { login_type } = this.props;
    let params = {
      firstname: firstname,
      lastname: lastname,
      email: email,
      phone: phone,
      role: login_type,
      ...(login_type==='MARKETING' && {metadata: {"AGENCY" : agency } })
    };
    this.props.addStaffMember(params);
  }
  changeStaffType = (event) => {
    console.log('Event',event.target.value);
    this.setState({
      role: event.target.value
    })
  }
  removeArrayElement=(array, element)=>{
    const index = array.indexOf(element);
    if (index > -1) {
        array.splice(index, 1);
    }
    return array;
  }

  handleChange = (event,target)=>{
   
    let errors  = [...this.state.errors];
    if(target === 'firstname'){
      if(event.target.value && event.target.value.trim().length>0){
        errors = this.removeArrayElement(errors,'firstname');
      }else{
        if(errors.indexOf('firstname')==-1)errors.push('firstname');
      }
    }
    
    if(target === 'lastname'){
      if(event.target.value && event.target.value.trim().length>0){
        errors = this.removeArrayElement(errors,'lastname');
      }else{
        if(errors.indexOf('lastname')==-1)errors.push('lastname');
      }
    }

    if(target === 'agency'){
      if(event.target.value && event.target.value.trim().length>0){
        errors = this.removeArrayElement(errors,'agency');
      }else{
        if(errors.indexOf('agency')==-1)errors.push('agency');
      }
    }
    
    if(target === 'email'){
      console.log('email',Utils.isValidEmail(event.target.value));
      if(event.target.value.length<1 || !Utils.isValidEmail(event.target.value)){
        if(errors.indexOf('email')==-1)errors.push('email');
      }else{
        errors = this.removeArrayElement(errors,'email');
      }
    }

    if(target === 'phone'){
      console.log('phone',Utils.isValidEmail(event.target.value));
      if(event.target.value.length<1 || !Utils.isValidPhone(event.target.value)){
        if(errors.indexOf('phone')==-1)errors.push('phone');
      }else{
        errors = this.removeArrayElement(errors,'phone');
      }
    }
    
    if(target!='role'){
    this.setState({
      [target]:event.target.value,
      errors
    });
    }else{
      this.setState({
        [target]:event.value,
        errors
      });
    }
  }


  disableAddCampaign =()=>{
    const { firstname,lastname, email, phone, role, errors, agency } = this.state;
    const { login_type } = this.props;
    if(firstname && lastname && email && phone && role && !this.props.staff.adding && errors.length==0){
      if(firstname.trim().length>0 &&lastname.trim().length>0 && email.trim().length>0 && phone.trim().length>0 && (login_type !== 'MARKETING' || agency.trim().length>0)){
        return false
      }
      console.log('1');
    }
    return true;
  }

 
  render() {
    const {modelopen, formresponse, auth, staff,business, features, login_type } = this.props;
    const { firstname,lastname, email, phone, role, errors ,roles, agency} = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Create-Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">{titles[login_type]}</div>
              <button className="modal-close" onClick={this.closeModal}>X</button>
              <div className="description">
              After you create account for a member they will get email invitation to finish setup and join {business.info.BUSINESS_NAME}.
              </div>
              <div className="input">
                <label className="label">First Name</label>
                <input type="text" value={firstname} onChange={e=>this.handleChange(e,'firstname')} maxlength="100"/>
                {errors.includes('firstname') && <div className="error-message">{errorMessage['firstname']}</div>}
              </div>
              <div className="input">
                <label className="label">last Name</label>
                <input type="text" value={lastname} onChange={e=>this.handleChange(e,'lastname')} maxlength="100"/>
                {errors.includes('lastname') && <div className="error-message">{errorMessage['lastname']}</div>}
              </div>
              <div className="input">
                <label className="label">Email</label>
                <input type="text" value={email} onChange={e=>this.handleChange(e,'email')} maxlength="100"/>
                {errors.includes('email') && <div className="error-message">{errorMessage['email']}</div>}
              </div>
              <div className="input">
                <label className="label">Phone Number</label>
                {/* <input type="text" value={phone} onChange={e=>this.handleChange(e,'phone')} maxlength="100"/> */}
                <PhoneInput
                    placeholder=""
                    name="phone"
                    value={phone}
                    onChange={e=>this.handleChange(e,'phone')}
                    className={classnames({
                      'has-error':
                        this.state.isPhoneBlank || this.state.isPhoneInvalid,
                    })}
                  />
                {errors.includes('phone') && <div className="error-message">{errorMessage['phone']}</div>}
              </div>
              {login_type === 'MARKETING' &&
              <div className="input">
                <label className="label">Agency</label>
                <input type="text" value={agency} onChange={e=>this.handleChange(e,'agency')} maxlength="100"/>
                {errors.includes('agency') && <div className="error-message">{errorMessage['agency']}</div>}
              </div>}
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.addCampaign} disabled={this.disableAddCampaign()}>
                    {staff.adding? 'Creating...': 'CREATE ACCOUNT'} 
                  </button>
                  <button className="btn btn--secondary btn--lg" onClick={this.closeModal}>CANCEL</button>
              </div>
              </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default CreateLayover;